import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { AdjustmentReason } from "../models/AdjustmentReason";

export const getAdjustmentReasons = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];
	const resp = await apiService.callV2(
		"[M2].[GetAdjustmentReasons]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as AdjustmentReason[];
	} else {
		throw new Error(resp.message || "Error fetching adjustments reasons");
	}
};
